import { ReactNode } from 'react';
import styled from 'styled-components';
import {
  Flex,
  FormControls,
  InfoTooltip,
} from '@elementary/common-ui/components';

const LABEL_WIDTH = 150;
const INFO_SLOT_WIDTH = 20;

const Row = styled(Flex)`
  display: grid;
  grid-template-columns: ${LABEL_WIDTH}px minmax(0, 1fr) ${INFO_SLOT_WIDTH}px;
  align-items: center;
  column-gap: 16px;
  width: 100%;
  min-width: 0;
  min-height: 40px;
`;

const Label = styled(FormControls.FormText)<{ $hasError?: boolean }>`
  white-space: nowrap;
  ${({ $hasError, theme }) =>
    $hasError && `color: ${theme.palette.common.red} !important;`}
`;

const ControlSlot = styled(Flex)`
  min-width: 0;
  width: 100%;
  align-items: center;
  gap: 8px;
  overflow: hidden;

  > * {
    min-width: 0;
    max-width: 100%;
  }

  .MuiInputBase-root {
    min-width: 0;
    max-width: 100%;
  }

  .MuiSelect-select {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const InfoSlot = styled(Flex)`
  width: ${INFO_SLOT_WIDTH}px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
`;

type Props = {
  label: string;
  info?: ReactNode;
  children: ReactNode;
  hasError?: boolean;
};

const FieldRow = ({ label, info, children, hasError }: Props) => (
  <Row>
    <Label $hasError={hasError}>{label}</Label>
    <ControlSlot>{children}</ControlSlot>
    <InfoSlot>{info != null ? <InfoTooltip title={info} /> : null}</InfoSlot>
  </Row>
);

export default FieldRow;
